import React, { useState, useEffect } from 'react';
import SectionHeader from '../../../home/components/SectionHeader';
import { SectionData } from '../../../home/types/types';
import Button from '../../buttons/SimpleButton/Button';

interface BenefitsCardsProps {
  benefitsData: any[];
  sectionDatas: SectionData;
  buttonText: string;
  buttonLink: string;
}

const BenefitsCards: React.FC<BenefitsCardsProps> = ({ benefitsData, sectionDatas, buttonText, buttonLink }) => {
  const isExternal = sectionDatas.linkIcon === 'external';

  const [theme, setTheme] = useState<'light' | 'dark'>((localStorage.getItem('theme') as 'light' | 'dark') || 'light');

  useEffect(() => {
    const handleStorageChange = () => {
      const newTheme = localStorage.getItem('theme') as 'light' | 'dark';
      if (newTheme) {
        setTheme(newTheme);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('themeChange', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('themeChange', handleStorageChange);
    };
  }, []);

  return (
    <div className="react-benefits-cards-block">
      {sectionDatas && (
        <SectionHeader
          title={sectionDatas.title}
          linkLabel={sectionDatas.sectionLinkText}
          url={sectionDatas.sectionUrl}
          hasPreIcon={sectionDatas.showIcon}
          isExternal={isExternal}
          iconUrl={sectionDatas.iconUrl}
          hasTitleLink={sectionDatas.hasTitleLink}
          hideHeader={sectionDatas.hideHeader}
        />
      )}

      <div className="react-benefits-cards-block__wrapper">
        {benefitsData.length > 0 &&
          benefitsData.map((benefit, index) => (
            <div className="benefits-card" key={index}>
              <div className="benefits-card__image-wrapper">
                <img
                  className="benefits-card__image"
                  src={theme === 'dark' && benefit.dark_mode_image ? benefit.dark_mode_image : benefit.background_image}
                  alt={benefit.title}
                />
              </div>
              <div className="benefits-card__content">
                <h6 className="benefits-card__title">{benefit.title}</h6>
                <div className="benefits-card__description" dangerouslySetInnerHTML={{ __html: benefit.content }} />
              </div>
            </div>
          ))}
      </div>

      {buttonText && (
        <div className="react-benefits-cards-block__button-wrapper">
          <Button className="" type="primary" size="large" label={buttonText} href={buttonLink} />
        </div>
      )}
    </div>
  );
};

export default BenefitsCards;
